module.exports = __webpack_public_path__ + "static/media/super-img-1.334e66d4.png";